import AlertMsg from "@/components/AlertMsg";
import NavBar from "@/components/NavBar";
import IconLoader from "@/components/IconLoader";
import IcoStatus from "@/components/ui/IcoStatus";
import IcoPic from "@/components/ui/IcoPic";
import IcoPicSmall from "@/components/ui/IcoPicSmall";
import IcoImg from "@/components/ui/IcoImg";
import UploadImg from "@/components/ui/UploadImg";

export default [
    AlertMsg,
    NavBar,
    IconLoader,
    IcoStatus,
    IcoPic,
    IcoPicSmall,
    IcoImg,
    UploadImg,
];
